import { MapperBase } from '../../utilities/mapper-base';
import { LoginTrackerResource } from '../resource/login-tracker.resource';
import { LoginAttempt } from '../ui/login-attempt.model';

export class LoginTrackerResourceToLoginAttemptMapper extends MapperBase<LoginTrackerResource, LoginAttempt> {
	map(source: LoginTrackerResource): LoginAttempt {
		const dest = new LoginAttempt();
		dest.isSuccessful = source.isLoginSuccess;
		dest.id = source.trackerId;
		dest.username = source.userName;
		dest.createdAt = source.utcDateTime;
		dest.ipAddress = source.userIPAddress;
		return dest;
	}
}


